const offlineFiles = {
  fr: {
    offlineFilesHint: 'Les photos et documents sont enregistrés sur ce téléphone, même hors connexion. Ils seront envoyés au projet dès que la connexion et le service seront disponibles.',
    offlineFileStorageError: 'Impossible d’enregistrer le fichier sur ce téléphone. Vérifiez l’espace disponible et réessayez.',
    offlineUploadPending: 'Enregistré sur ce téléphone · en attente d’envoi',
    offlineUploadRejected: 'Envoi refusé · fichier conservé sur ce téléphone. Réessayez après vérification.',
  },
  en: {
    offlineFilesHint: 'Photos and documents are saved on this phone, even offline. They will be sent to the project when the connection and service are available.',
    offlineFileStorageError: 'Could not save the file on this phone. Check available space and try again.',
    offlineUploadPending: 'Saved on this phone · waiting to upload',
    offlineUploadRejected: 'Upload rejected · file kept on this phone. Check and retry.',
  },
  es: {
    offlineFilesHint: 'Las fotos y los documentos se guardan en este teléfono, incluso sin conexión. Se enviarán al proyecto cuando haya red y el servicio esté disponible.',
    offlineFileStorageError: 'No se pudo guardar el archivo en este teléfono. Comprueba el espacio disponible e inténtalo de nuevo.',
    offlineUploadPending: 'Guardado en este teléfono · pendiente de envío',
    offlineUploadRejected: 'Envío rechazado · archivo conservado en este teléfono. Revísalo y reintenta.',
  },
  pt: {
    offlineFilesHint: 'Fotos e documentos são salvos neste telefone, mesmo sem conexão. Serão enviados ao projeto quando a rede e o serviço estiverem disponíveis.',
    offlineFileStorageError: 'Não foi possível salvar o arquivo neste telefone. Verifique o espaço disponível e tente novamente.',
    offlineUploadPending: 'Salvo neste telefone · aguardando envio',
    offlineUploadRejected: 'Envio recusado · arquivo mantido neste telefone. Verifique e tente novamente.',
  },
  vi: {
    offlineFilesHint: 'Ảnh và tài liệu được lưu trên điện thoại này ngay cả khi ngoại tuyến. Chúng sẽ được gửi vào dự án khi có mạng và dịch vụ hoạt động.',
    offlineFileStorageError: 'Không thể lưu tệp trên điện thoại này. Hãy kiểm tra dung lượng trống và thử lại.',
    offlineUploadPending: 'Đã lưu trên điện thoại · chờ tải lên',
    offlineUploadRejected: 'Tải lên bị từ chối · tệp vẫn ở trên điện thoại. Hãy kiểm tra và thử lại.',
  },
  hi: {
    offlineFilesHint: 'फ़ोटो और दस्तावेज़ ऑफ़लाइन भी इस फ़ोन पर सुरक्षित रहते हैं। कनेक्शन और सेवा उपलब्ध होने पर वे परियोजना में भेजे जाएँगे।',
    offlineFileStorageError: 'इस फ़ोन पर फ़ाइल सहेजी नहीं जा सकी। उपलब्ध जगह जाँचें और फिर कोशिश करें।',
    offlineUploadPending: 'इस फ़ोन पर सुरक्षित · भेजे जाने की प्रतीक्षा',
    offlineUploadRejected: 'अपलोड अस्वीकार हुआ · फ़ाइल फ़ोन पर सुरक्षित है। जाँच कर फिर कोशिश करें।',
  },
  ar: {
    offlineFilesHint: 'تُحفظ الصور والمستندات على هذا الهاتف حتى دون اتصال. وستُرسل إلى المشروع عند توفر الشبكة والخدمة.',
    offlineFileStorageError: 'تعذر حفظ الملف على هذا الهاتف. تحقق من المساحة المتاحة وحاول مجدداً.',
    offlineUploadPending: 'محفوظ على هذا الهاتف · بانتظار الإرسال',
    offlineUploadRejected: 'رُفض الرفع · الملف محفوظ على هذا الهاتف. تحقق منه وأعد المحاولة.',
  },
  ur: {
    offlineFilesHint: 'تصاویر اور دستاویزات آف لائن بھی اس فون پر محفوظ رہتی ہیں۔ نیٹ ورک اور سروس دستیاب ہونے پر انہیں منصوبے میں بھیج دیا جائے گا۔',
    offlineFileStorageError: 'اس فون پر فائل محفوظ نہیں ہو سکی۔ دستیاب جگہ چیک کریں اور دوبارہ کوشش کریں۔',
    offlineUploadPending: 'اس فون پر محفوظ · بھیجے جانے کی منتظر',
    offlineUploadRejected: 'اپ لوڈ مسترد ہوئی · فائل فون پر محفوظ ہے۔ جانچ کر دوبارہ کوشش کریں۔',
  },
};

export default offlineFiles;
